export default __webpack_public_path__ + "static/media/vietgot-screenshot-01.4cb65288.png";